import axios from "axios";
import {
  NOMINEE_FAILED,
  NOMINEE_REQUEST,
  NOMINEE_SUCCESS,
  POST_ACCOUNT_FAILED,
  POST_ACCOUNT_REQUEST,
  POST_ACCOUNT_SUCCESS,
  RETRIEVE_ACCOUNT_FAILED,
  RETRIEVE_ACCOUNT_REQUEST,
  RETRIEVE_ACCOUNT_SUCCESS,
} from "./types";
import { setAlert } from "./alertActions";

export const nomineeDecrypt = (userId, secretKey) => async (dispatch) => {
  dispatch({ type: NOMINEE_REQUEST });
  const url = "https://bekeeper.onrender.com/account/nominee";
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({
    secretkey: secretKey,
    userid: userId
  });

  try {
    const response = await axios.post(url, body, config);
    dispatch({ type: NOMINEE_SUCCESS, payload: response.data });

  } catch (error) {
    dispatch({ type: NOMINEE_FAILED });

    dispatch(
      setAlert(
        "Could not retrieve informaion, please check the credentials...",
        2,
        "error"
      )
    );
    console.error(error);
  }

};

export const editNote =
  (token, secretKey, text, nominee1, nominee2, nominee3) =>
  async (dispatch) => {
    dispatch({ type: POST_ACCOUNT_REQUEST });

    const url = "https://bekeeper.onrender.com/account/edit";

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
          text: text,
        },
      };

      const body = JSON.stringify({
        secretkey: secretKey,
        nominee1,
        nominee2,
        nominee3,
      });

      const response = await axios.put(url, body, config);
      console.log(response);
      dispatch({ type: POST_ACCOUNT_SUCCESS, payload: response.data });
      dispatch(setAlert("Changes have been saved!", 2, "success"));
    } catch (error) {
      dispatch({ type: POST_ACCOUNT_FAILED });

      dispatch(
        setAlert(
          "Could not save information, please check the secret key",
          2,
          "error"
        )
      );
      console.error(error);
    }
  };

export const postNote =
  (token, secretKey, text, nominee1, nominee2, nominee3) =>
  async (dispatch) => {
    dispatch({ type: POST_ACCOUNT_REQUEST });

    const url = "https://bekeeper.onrender.com/account/";

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
          text: text,
        },
      };

      const body = JSON.stringify({
        secretkey: secretKey,
        nominee1,
        nominee2,
        nominee3,
      });

      const response = await axios.post(url, body, config);
      console.log(response);
      dispatch({ type: POST_ACCOUNT_SUCCESS, payload: response.data });
      dispatch(setAlert("Changes have been saved!", 2, "success"));
    } catch (error) {
      dispatch({ type: POST_ACCOUNT_FAILED });

      dispatch(
        setAlert(
          "Could not save information, please check the secret key",
          5,
          "error"
        )
      );
      console.error(error);
    }
  };

export const getNote = (token, secretKey) => async (dispatch) => {
  dispatch({ type: RETRIEVE_ACCOUNT_REQUEST });

  const url = "https://bekeeper.onrender.com/account/info";

  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
    };

    const body = JSON.stringify({ secretkey: secretKey });

    const response = await axios.post(url, body, config);

    dispatch({ type: RETRIEVE_ACCOUNT_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: RETRIEVE_ACCOUNT_FAILED });
    dispatch(
      setAlert(
        "Could not retrieve information, please check the secret key",
        2,
        "error"
      )
    );
    console.error(error);
  }
};
